import React from 'react';

interface Apartment {
  floor?: string | number;
  surface?: number;
  rooms?: number;
  salons?: number;
  bathrooms?: number;
  price?: number;
}

interface Bien {
  type: string;
  apartments?: Apartment[];
  studios?: Apartment[];
  duplexes?: Apartment[];
}

const formatPrice = (price?: number) => {
  if (price == null) return '-';
  return price.toLocaleString('fr-FR');
};

interface Props {
  bien: Bien;
}

const BienDetailsTables: React.FC<Props> = ({ bien }) => {
  if (bien.type.toLowerCase() !== 'immeuble') return null;

  const hasValidData = (items?: Apartment[]) => {
    if (!items || items.length === 0) return false;
    return items.some(apt =>
      (apt.floor !== undefined && apt.floor !== null && apt.floor !== '') ||
      (apt.surface !== undefined && apt.surface !== null && apt.surface > 0) ||
      (apt.rooms !== undefined && apt.rooms !== null && apt.rooms > 0) ||
      (apt.salons !== undefined && apt.salons !== null && apt.salons > 0) ||
      (apt.bathrooms !== undefined && apt.bathrooms !== null && apt.bathrooms > 0) ||
      (apt.price !== undefined && apt.price !== null && apt.price > 0)
    );
  };

  const tablesToRender: { items: Apartment[] | undefined; label: string }[] = [];

  if (hasValidData(bien.apartments)) {
    tablesToRender.push({ items: bien.apartments, label: 'Liste des appartements' });
  }
  if (hasValidData(bien.studios)) {
    tablesToRender.push({ items: bien.studios, label: 'Liste des studios' });
  }
  if (hasValidData(bien.duplexes)) {
    tablesToRender.push({ items: bien.duplexes, label: 'Liste des duplex' });
  }

  return (
    <>
      {tablesToRender.map(({ items, label }) => (
        <div key={label} className="mt-12">
          <h3 className="text-xl font-semibold mb-4 text-luxe-blue">{label}</h3>
          <div className="overflow-x-auto">
            <table
              className="min-w-full table-auto border border-gray-300 rounded-md text-sm"
              aria-label={label}
            >
              <thead className="bg-gray-100">
                <tr>
                  {['Étage', 'Surface', 'Chambres', 'Salons', 'SDB', 'Prix'].map((header) => (
                    <th
                      key={header}
                      className="px-4 py-2 border text-center whitespace-nowrap"
                    >
                      {/* Titre horizontal sur md+ / vertical sur mobile */}
                      <span className="hidden md:inline">{header}</span>
                      <span
                        className="block md:hidden"
                        style={{
                          writingMode: 'vertical-rl',
                          transform: 'rotate(180deg)',
                          fontWeight: '600',
                          lineHeight: '1rem',
                        }}
                      >
                        {header}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {items!.map((apt, index) => (
                  <tr key={index} className="hover:bg-gray-50 text-center">
                    <td className="border px-2 py-2">{apt.floor ?? '-'}</td>
                    <td className="border px-2 py-2">{apt.surface ? `${apt.surface} m²` : '-'}</td>
                    <td className="border px-2 py-2">{apt.rooms ?? '-'}</td>
                    <td className="border px-2 py-2">{apt.salons ?? '-'}</td>
                    <td className="border px-2 py-2">{apt.bathrooms ?? '-'}</td>
                    <td className="border px-2 py-2">{formatPrice(apt.price)} MAD</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </>
  );
};

export default BienDetailsTables;
